export const BUTTONS = {
  EDIT: "edit",
  VIEW_DETAILS: "viewDetails",
  REVIEW_COMPLETED: "reviewCompleted",
  REVIEW: "review",
  APPROVE: "approve",
  DENY: "deny"
};
